import { __assign } from '../../../../../../../node_modules/tslib/tslib.es6.js';
import { useState, useRef, useCallback, useEffect } from 'react';
import { useDeepCompareEffect } from 'react-use';

var useInfinitePaginatedQuery = function (_a) {
    var _b, _c, _d;
    var useQuery = _a.useQuery, queryExtraParams = _a.queryExtraParams, initialLimit = _a.initialLimit;
    var _e = useState({
        pageIndex: 0,
        pageSize: initialLimit || 30,
    }), pagination = _e[0], setPagination = _e[1];
    var from = useRef({});
    var reset = useCallback(function () {
        setPagination(function (v) { return (__assign(__assign({}, v), { pageIndex: 0 })); });
        from.current = {};
    }, [from]);
    var queryResponse = useQuery(__assign(__assign({}, (queryExtraParams || {})), { limit: pagination.pageSize, from: ((_b = from.current) === null || _b === void 0 ? void 0 : _b[pagination.pageIndex]) || "" }), { refetchOnMountOrArgChange: true });
    useEffect(reset, [pagination.pageSize]);
    useDeepCompareEffect(function () {
    }, [queryExtraParams]);
    useEffect(function () {
        var _a, _b;
        if (from.current && (queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.data)) {
            from.current[pagination.pageIndex + 1] = ((_b = (_a = queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.data) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.from) || "";
        }
    }, [queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.data]);
    return __assign(__assign({ pagination: pagination, setPagination: setPagination }, queryResponse), { hasMore: ((_d = (_c = queryResponse === null || queryResponse === void 0 ? void 0 : queryResponse.data) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length) === pagination.pageSize });
};

export { useInfinitePaginatedQuery as default };
